import React, { Fragment, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './styles.scss';
import CardBody from './card-body';
import CardFooter from './card-footer';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import { OrderType } from 'models/order.model';
import { getOrderStatus } from 'utils/functions';
import OrderStatus from 'components/base/order-status';
import OrderDetail from 'pages/order-details';
import { BaseModal } from '@cokitchen/cokitchen-components';

type Props = {
  orders: OrderType[];
};
const OrderHistoryCards = ({ orders }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeOrder, setActiveOrder] = useState<OrderType>();
  const [showOrderModal, setShowOrderModal] = useState(false);
  useEffect(() => {
    setShowOrderModal(!!activeOrder);
    if (activeOrder) {
      searchParams.set('order', activeOrder.order_code);
      searchParams.set('orderStatus', getOrderStatus(activeOrder));
    } else {
      if (searchParams.has('order')) {
        searchParams.delete('order');
        searchParams.delete('orderStatus');
      }
    }
    setSearchParams(searchParams);
  }, [activeOrder]);

  const closeOrderModal = () => {
    setActiveOrder(undefined);
  };
  return (
    <Fragment>
      <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
        {orders?.map((order) => (
          <div
            onClick={() => {
              setActiveOrder(order);
            }}
            key={order.id}
            className='cursor-pointer order-history-card relative'>
            <CardBody order={order} />
            <CardFooter order={order} />
          </div>
        ))}
      </div>

      <BaseModal
        position='right'
        isOpen={showOrderModal}
        onRequestClose={closeOrderModal}
        size='wide'
        title={
          <div className='flex flex-wrap lg:flex-nowrap gap-2 items-center'>
            <button onClick={closeOrderModal}>
              <ArrowLeftIcon className='w-6 h-6' />
            </button>
            <div className='font-semibold text-2xl'>
              Order #{activeOrder?.order_code?.toUpperCase()}
            </div>

            {activeOrder && (
              <div className='basis-full lg:basis-auto'>
                <OrderStatus type={getOrderStatus(activeOrder)} />
              </div>
            )}
          </div>
        }>
        {activeOrder && <OrderDetail orderCode={activeOrder?.order_code} />}
      </BaseModal>
    </Fragment>
  );
};

export default OrderHistoryCards;
